import { STATUS_COLUMN_FRACTION } from '../Alerts.constants';
import { truncatedNameStyles } from '../Alerts.styles';

export const accordionCategoryCustomStyles = {
  width: '100%',
  boxShadow: 'unset',
  padding: '4px 0 !important',
  '.MuiAccordionSummary-root': {
    flexDirection: 'row-reverse',
    '.MuiAccordionSummary-content.Mui-expanded': {
      margin: 0,
    },
  },
  '.MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 'unset',
    '.accordion-summary-container': {
      backgroundColor: ({ palette }) => palette.primary.extraSoft,
      borderColor: 'transparent',
    },
  },
  '.MuiAccordionSummary-expandIconWrapper': {
    marginRight: '4px',
    backgroundColor: ({ palette }) => palette.background.secondary,
    borderRadius: ({ shape }) => shape.radius.s,
    marginLeft: '16px',
    transform: 'rotate(-90deg)',
    '&.Mui-expanded': {
      transform: 'rotate(0deg)',
    },
    color: ({ palette }) => palette.text.secondary,
  },
  '.MuiStack-root': {
    padding: 0,
  },
  '.accordion-summary-title': {
    ...truncatedNameStyles,
    fontSize: '14px',
    fontWeight: '400',
    color: ({ palette }) => palette.text.primary,
    lineHeight: '22px',
  },
  '.accordion-summary-container': {
    height: '100%',
    borderRadius: ({ shape }) => shape.radius.s,
    border: ({ palette }) => `1px solid ${palette.border.default}`,
    padding: '13px 16px',
    marginRight: '12px',
    position: 'relative',
  },
  '.MuiAccordionDetails-root': {
    paddingBottom: 0,
  },
};

// The category summary row is a single full-width cell, so its status glyph is
// positioned to land in the table's Status column exactly as item rows do:
// a right-anchored overlay whose trailing spacers equal the Action Date and
// Action column widths, leaving the Status cell aligned above them.
// pointerEvents:none keeps the accordion toggle clickable through the overlay.
export const categoryStatusOverlayStyles = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: '4px',
  bottom: '4px',
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  pointerEvents: 'none',
};

// Item rows compute each trailing column as getCalc((100% + diff) * pct) — diff is
// BASE_PADDING_PX (12) at their first nesting level — so every item's status glyph
// lands on one invariant vertical line. The category cells must use the SAME basis
// or the glyph sits ~5px off; mirror the item column formula here.
const ITEM_COLUMN_BASIS_OFFSET_PX = 12;
const ACTION_DATE_COLUMN_FRACTION = 0.14;
const ACTION_COLUMN_FRACTION = 0.22;
const itemColumnWidth = fraction => `calc((100% + ${ITEM_COLUMN_BASIS_OFFSET_PX}px) * ${fraction})`;

export const categoryStatusCellStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  width: itemColumnWidth(STATUS_COLUMN_FRACTION),
};

export const categoryActionDateCellStyles = {
  display: 'flex',
  alignItems: 'center',
  width: itemColumnWidth(ACTION_DATE_COLUMN_FRACTION),
};

export const categoryActionCellStyles = {
  width: itemColumnWidth(ACTION_COLUMN_FRACTION),
};
